import { AnyAction, CombinedState, combineReducers } from "@reduxjs/toolkit";
import sampleReducer from "../slices/sample";
import sharedReducer from "../slices/shared";
import tileReducer from "../slices/tile";
import authReducer from "../slices/auth";
import dashboardReducer from "../slices/dashboard";
import connectionReducer from "../slices/connection";
import dataReducer from "../slices/data";
import filterReducer from "../slices/filter";
import alertReducer from "../slices/alert";
import userReducer from "../slices/user";
import settingsReducer from "../slices/settings";
import emailGroupReducer from "../slices/emailGroup";
import reportReducer from "../slices/report";
import scheduleReducer from "../slices/schedule";

const globalReducer = combineReducers({
  alert: alertReducer,
  shared: sharedReducer,
  auth: authReducer,
  connection: connectionReducer,
  dashboard: dashboardReducer,
  data: dataReducer,
  filter: filterReducer,
  sample: sampleReducer,
  settings: settingsReducer,
  tiles: tileReducer,
  users: userReducer,
  emails: emailGroupReducer,
  report: reportReducer,
  schedules: scheduleReducer,
});

const rootReducer = (state: CombinedState<any>, action: AnyAction) => {
  if (action.type === "auth/logout/fulfilled") {
    return globalReducer(undefined, action);
  }

  return globalReducer(state, action);
};

export default rootReducer;
